module.exports = __webpack_public_path__ + "img/sm-164906147078120220217081728.85625e5a.jpg";